// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"KZ-z","subtitle":"LZ-z","wrapper":"MZ-z","leftArrow":"NZ-z","rightArrow":"OZ-z"};